import type { PaginatedResponse } from "@/features/profiles/services/profiles/types";

export enum CollectionRedirectType {
  PACKS = "PACKS",
  PRESETS = "PRESETS",
  CREATORS = "CREATORS",
  LIST_OF_PACKS = "LIST_OF_PACKS",
  LIST_OF_PRESETS = "LIST_OF_PRESETS",
  SUBSCRIPTION = "SUBSCRIPTION",
}

export interface CollectionTranslation {
  languageCode: string;
  description: string;
}

// Tipos para resposta da API (com ids)
export interface CollectionTranslationResponse extends CollectionTranslation {
  id: string;
}

export interface CollectionImageResponse {
  id: string;
  url: string;
}

export interface CollectionItem {
  itemId: string;
  displayOrder: number;
  image?: string; // URL da imagem do item (opcional, vem da API)
  name?: string; // Nome do item (opcional, vem da API)
}

export interface CollectionBanner {
  id?: string; // ID do banner (usado no PUT)
  redirectType: CollectionRedirectType;
  isActive: boolean;
  startDate: string; // ISO datetime
  endDate: string; // ISO datetime
}

// Tipo para resposta da API do banner
export interface CollectionBannerResponse extends CollectionBanner {
  id: string;
  bannerImage?: CollectionImageResponse;
}

export interface Collection {
  id: string; // uuid
  name: string;
  description: string;
  cover: string;
  translations?: CollectionTranslation[];
  items?: CollectionItem[];
  banner?: CollectionBanner;
  bannerImageUrl?: string; // URL da imagem do banner (para preview)
  createdAt: string; // ISO datetime
  updatedAt: string; // ISO datetime
}

export interface CollectionListItem {
  id: string;
  name: string;
  description: string | null;
  cover: string;
  isActive: boolean;
  createdAt: string; // ISO datetime
  startDate?: string | null; // ISO datetime ou string vazia
  endDate?: string | null; // ISO datetime ou string vazia
  redirectType?: CollectionRedirectType;
}

export interface GetCollectionsParams {
  page?: number;
  limit?: number;
  isActive?: boolean;
}

export type PaginatedCollectionsResponse = PaginatedResponse<CollectionListItem>;

export interface CreateCollectionPayload {
  collection: {
    name: string;
    translations?: CollectionTranslation[];
    items?: CollectionItem[];
  };
  banner?: {
    redirectType: CollectionRedirectType;
    isActive: boolean;
    startDate: string; 
    endDate: string; 
  };
  coverImage?: File;
  bannerImage?: File;
}

export interface UpdateCollectionPayload {
  collection?: {
    id?: string; // ID necessário para PUT
    name?: string;
    translations?: CollectionTranslation[];
    items?: CollectionItem[];
  };
  banner?: {
    id?: string; // ID necessário para PUT
    redirectType?: CollectionRedirectType;
    isActive?: boolean;
    startDate?: string; 
    endDate?: string; 
  };
  coverImage?: File;
  bannerImage?: File;
}

// Tipo para item retornado pela API
export interface CollectionItemResponse {
  itemId: string;
  displayOrder: number;
  image: string;
  name: string;
}

// Tipo para resposta completa da API GET by ID
export interface CollectionResponse {
  collection: {
    id: string;
    name: string;
    coverImage?: CollectionImageResponse;
    translations?: CollectionTranslationResponse[];
    items?: CollectionItemResponse[];
    createdAt: string;
    updatedAt: string;
  };
  banner?: CollectionBannerResponse;
}
